<i class="fa fa-{{ name }}" aria-hidden="true" [ngClass]="optionalClasses" ></i> 